//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import TopoTitleComponente from '../Topo/TopoTitleComponente';
import { reprocessarIntegracoesService } from '../../services/reprocessarIntegracoes.service';

class ReprocessarIntegracoesPage extends React.PureComponent<Props> {
  state = {
    processandoProdutos: false,
    protocoloProdutos: null,
    statusProdutos: null,
    mensagemProdutos: null,
    detalheProdutos: null,
  };

  pollingProdutos = null;

  componentWillUnmount() {
    if (this.pollingProdutos) {
      clearInterval(this.pollingProdutos);
    }
  }

  formatarData = (data) => {
    if (!data) {
      return '-';
    }

    return moment(data).format('DD/MM/YYYY HH:mm:ss');
  };

  finalizarPollingProdutos = () => {
    if (this.pollingProdutos) {
      clearInterval(this.pollingProdutos);
      this.pollingProdutos = null;
    }

    this.setState({
      processandoProdutos: false,
    });
  };

  reprocessarProdutos = () => {
    this.setState({
      processandoProdutos: true,
      protocoloProdutos: null,
      statusProdutos: 'EM_EXECUCAO',
      mensagemProdutos: 'Iniciando reprocessamento de produtos...',
      detalheProdutos: null,
    });

    reprocessarIntegracoesService.reprocessarProdutos().then(
      (response) => {
        const protocolo =
          response && response.data ? response.data.protocolo : null;

        this.setState({
          protocoloProdutos: protocolo,
          statusProdutos: response.data.status,
          mensagemProdutos: response.data.mensagem,
          detalheProdutos: response.data.detalhe,
        });

        this.props.success({
          message: 'Reprocessamento de produtos iniciado.',
        });

        if (protocolo) {
          this.iniciarPollingProdutos(protocolo);
        } else {
          this.setState({ processandoProdutos: false });
        }
      },
      (error) => {
        console.log(error);
        this.setState({
          processandoProdutos: false,
          statusProdutos: 'ERRO',
          mensagemProdutos: 'Erro ao iniciar reprocessamento de produtos.',
          detalheProdutos: null,
        });

        this.props.error({
          message: 'Erro ao iniciar reprocessamento de produtos.',
        });
      },
    );
  };

  iniciarPollingProdutos = (protocolo) => {
    if (this.pollingProdutos) {
      clearInterval(this.pollingProdutos);
    }

    this.pollingProdutos = setInterval(() => {
      reprocessarIntegracoesService.consultar(protocolo).then(
        (response) => {
          const data = response.data;

          this.setState({
            statusProdutos: data.status,
            mensagemProdutos: data.mensagem,
            detalheProdutos: data.detalhe,
          });

          if (data.status === 'FINALIZADO') {
            this.finalizarPollingProdutos();

            this.props.success({
              message: 'Reprocessamento de produtos finalizado.',
            });
          }

          if (data.status === 'FINALIZADO_COM_ERRO') {
            this.finalizarPollingProdutos();

            this.props.error({
              message:
                data.mensagem ||
                'Reprocessamento de produtos finalizado com erros.',
            });
          }

          if (data.status === 'ERRO') {
            this.finalizarPollingProdutos();

            this.props.error({
              message: data.mensagem || 'Erro no reprocessamento de produtos.',
            });
          }
        },
        (error) => {
          console.log(error);
          this.finalizarPollingProdutos();

          this.setState({
            statusProdutos: 'ERRO',
            mensagemProdutos: 'Erro ao consultar status do reprocessamento.',
          });

          this.props.error({
            message: 'Erro ao consultar status do reprocessamento.',
          });
        },
      );
    }, 5000);
  };

  renderResumoFiliais = () => {
    const { detalheProdutos } = this.state;
    const filiais =
      detalheProdutos && detalheProdutos.filiais ? detalheProdutos.filiais : [];

    if (!filiais.length) {
      return null;
    }

    return (
      <details className="mt-3">
        <summary>Ver detalhes por filial ({filiais.length})</summary>

        <div className="table-responsive mt-2">
          <table className="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Filial</th>
                <th>Status</th>
                <th>Última chamada anterior</th>
                <th>Busca de</th>
                <th>Busca até</th>
                <th>Nova referência</th>
                <th>Processados</th>
                <th>Inseridos</th>
                <th>Atualizados</th>
                <th>Erros</th>
                <th>Último produto salvo</th>
              </tr>
            </thead>
            <tbody>
              {filiais.map((filial, index) => (
                <tr key={index}>
                  <td>{filial.filialId || '-'}</td>
                  <td>{filial.status || '-'}</td>
                  <td>{this.formatarData(filial.ultimaChamadaAnterior)}</td>
                  <td>{this.formatarData(filial.dataReferenciaInicio)}</td>
                  <td>{this.formatarData(filial.dataReferenciaFim)}</td>
                  <td>{this.formatarData(filial.ultimaChamadaAtualizada)}</td>
                  <td>{filial.produtosProcessados || 0}</td>
                  <td>{filial.produtosInseridos || 0}</td>
                  <td>{filial.produtosAtualizados || 0}</td>
                  <td>{filial.produtosComErro || 0}</td>
                  <td>
                    {filial.ultimoProdutoSalvoEm
                      ? `${this.formatarData(
                          filial.ultimoProdutoSalvoEm,
                        )} - ${filial.ultimoProdutoSalvoCodigo || ''}`
                      : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </details>
    );
  };

  renderStatusProdutos = () => {
    const {
      statusProdutos,
      mensagemProdutos,
      protocoloProdutos,
      detalheProdutos,
    } = this.state;

    const erros =
      detalheProdutos && detalheProdutos.erros ? detalheProdutos.erros : [];

    if (!statusProdutos && !mensagemProdutos) {
      return null;
    }

    return (
      <div className="mt-3">
        {statusProdutos && (
          <p className="mb-1">
            <b>Status:</b> {statusProdutos}
          </p>
        )}

        {mensagemProdutos && (
          <p className="mb-1">
            <b>Mensagem:</b> {mensagemProdutos}
          </p>
        )}

        {detalheProdutos && (
          <div className="mt-2">
            <p className="mb-1">
              <b>Iniciado em:</b>{' '}
              {this.formatarData(detalheProdutos.iniciadoEm)}
            </p>

            <p className="mb-1">
              <b>Finalizado em:</b>{' '}
              {this.formatarData(detalheProdutos.finalizadoEm)}
            </p>
            <p className="mb-1">
              <b>Último produto salvo:</b>{' '}
              {detalheProdutos.ultimoProdutoSalvoEm
                ? `${this.formatarData(
                    detalheProdutos.ultimoProdutoSalvoEm,
                  )} - ${detalheProdutos.ultimoProdutoSalvoCodigo ||
                    ''} ${detalheProdutos.ultimoProdutoSalvoDescricao || ''}`
                : 'Nenhum produto salvo nesta execução'}
            </p>

            <p className="mb-1">
              <b>Filiais processadas:</b>{' '}
              {detalheProdutos.filiaisProcessadas || 0}
            </p>

            <p className="mb-1">
              <b>Filiais com sucesso:</b>{' '}
              {detalheProdutos.filiaisComSucesso || 0}
            </p>

            <p className="mb-1">
              <b>Filiais com erro:</b> {detalheProdutos.filiaisComErro || 0}
            </p>

            <p className="mb-1">
              <b>Produtos processados:</b>{' '}
              {detalheProdutos.produtosProcessados || 0}
            </p>

            <p className="mb-1">
              <b>Produtos inseridos:</b>{' '}
              {detalheProdutos.produtosInseridos || 0}
            </p>

            <p className="mb-1">
              <b>Produtos atualizados:</b>{' '}
              {detalheProdutos.produtosAtualizados || 0}
            </p>

            <p className="mb-1">
              <b>Produtos com erro:</b> {detalheProdutos.produtosComErro || 0}
            </p>

            {this.renderResumoFiliais()}
          </div>
        )}

        {erros.length > 0 && (
          <details className="mt-3">
            <summary>Ver detalhes dos erros ({erros.length})</summary>

            <div className="mt-2">
              {erros.slice(0, 50).map((erro, index) => (
                <div key={index} className="alert alert-warning py-2 mb-2">
                  {erro}
                </div>
              ))}

              {erros.length > 50 && (
                <p>Exibindo os primeiros 50 erros de {erros.length}.</p>
              )}
            </div>
          </details>
        )}

        {protocoloProdutos && (
          <p className="mb-0 mt-2">
            <b>Protocolo:</b> {protocoloProdutos}
          </p>
        )}
      </div>
    );
  };

  render() {
    const { processandoProdutos } = this.state;

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle="Reprocessar Integrações"
          subTitle="Execução manual de integrações"
          canBack={true}
        />

        <div className="flex-column p-2 w-100">
          <div className="d-flex flex-column mb-0">
            <div className="form-row">
              <div className="col-12 col-md-10 col-lg-4 mb-3">
                <div className="card p-4 h-100">
                  <h4>Produtos</h4>

                  <p>
                    Sincroniza os produtos cadastrados no Omie com o WMS. Use
                    quando houver produto novo e a mercadoria já estiver
                    aguardando recebimento.
                  </p>

                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={processandoProdutos}
                    onClick={this.reprocessarProdutos}
                  >
                    {processandoProdutos
                      ? 'Reprocessando produtos...'
                      : 'Reprocessar produtos'}
                  </button>

                  {this.renderStatusProdutos()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatch = ({ alert: { success, error } }) => ({
  success: (msg) => success(msg),
  error: (msg) => error(msg),
});

export default connect(
  null,
  mapDispatch,
)(ReprocessarIntegracoesPage);
